import React from 'react';
import VideoItem from './VideoItem';
import { useSelectionContext } from '../../../contexts/SelectionContext';

const VideoCard = () => {
    const { isItemSelected, selectionList } = useSelectionContext();
    const videoItems = selectionList.map((selection) => {
        return (
            isItemSelected(selection.topic) && (
                <VideoItem
                    key={`card-item-${selection}`}
                    title={selection.title}
                    text={selection.text}
                    icon={selection.icon}
                    video={selection.video}
                />
            )
        );
    });
    return (
        <div className="card flex flex-col-reverse items-center justify-between lg:flex-row lg:space-x-5 lg:items-start lg:w-8/12 xl:w-9/12">
            {videoItems}
        </div>
    );
};

export default VideoCard;
